import { useEffect, useRef } from "react";
import type Page from "../models/Page";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import ConsumerEditView from "../modelViews/ConsumerEditView";
import { useRedraw } from "../models/useRerender";

export default function DrawingItemEditContainer(props: { page: Page }) {
  const { page } = props;

  const redraw = useRedraw();

  const thisElement = useRef<HTMLDivElement>(null);

  useOnChangeWatcher(state.currentEditObject);

  useOnChangeWatcher(page.currentZoom, () => {
    updatePosition();
    return false;
  });

  useOnChangeWatcher(page.currentPan, () => {
    updatePosition();
    return false;
  });

  useOnChangeWatcher(state.currentEditObjectPosition);

  useEffect(() => {
    updatePosition();
  });

  function updatePosition() {
    if (thisElement.current && state.currentEditObject.value) {
      const p = state.currentEditObject.value.getScreenPosition(page);
      let x = p.x;
      let y = p.y;

      const pageElment = thisElement.current.closest(".pane");
      if (pageElment) {
        const r = pageElment.getBoundingClientRect();
        x -= r.left;
        y -= r.top;
      }
      thisElement.current.style.left = x + "px";
      thisElement.current.style.top = y + "px";
    }
  }

  const obj = state.currentEditObject.value;
  if (!obj || obj.isDeleted) {
    return null;
  }

  if ((obj && obj.className == "Consumer") || obj.className == "Button") {
    return (
      <div
        className="DrawingItemEditContainer"
        ref={thisElement}
        style={{
          position: "absolute",
          left: state.currentEditObjectPosition.value.x + "px",
          top: state.currentEditObjectPosition.value.y + "px",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ConsumerEditView connetableObject={obj} page={page} mainPage={page} />
      </div>
    );
  } else {
    return null;
  }
}
